import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import OurServicesCard from '../OurServicesCard/OurServicesCard'
import OurServicesCardImg1 from "../../assests/img/Endodontic.jpg"
import OurServicesCardImg2 from "../../assests/img/mouthguard.jpg"
import OurServicesCardImg3 from "../../assests/img/Orthodontics.jpg"
import OurServicesCardImg4 from "../../assests/img/our-services-card-img4.jpg"
// import OurServicesCardImg5 from "../../assests/img/Pedodontic.jpg"
import restorative from "../../assests/img/Restorative-Services-In-Dental.jpg"
import OurServicesCardImg5 from "../../assests/img/prosthodontics services image.jpg"
import OurServicesCardImg6 from "../../assests/img/Regular Checkup.jpg"
import cosmetic from "../../assests/img/our-services-card-img6.png"
import OurServicesCardImg7 from "../../assests/img/splints.jpg"
import OurServicesCardImg8 from "../../assests/img/ToothRemoval.jpg"
import OurServicesCardImg9 from "../../assests/img/our-services-card-img9.png"
import OurServicesCardImg10 from "../../assests/img/Pedodontic.jpg"
import 'react-alice-carousel/lib/alice-carousel.css';
import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from "react-icons/io5";


const OurServices = () => {
    const handleBookNow = () => {
        window.open("https://shellharbourroaddentists.portal.dental", "_blank");
    };

    const responsive = {
        0:{items:1},
        400: { items: 1 }, 
        568: { items: 3 },
        1024: { items: 4 },
        1300: { items: 4 },
    };

    const OurServicesData = [
        {
            image: OurServicesCardImg4,
            heading: "Emergency Services to relieve pain & discomfort",
            desc: <div>Contact us immediately if you are experiencing:<br />
                •	tooth ache<br />
                •	sore jaw<br />
                •	pain in joint<br />
                •	swollen face/abscess<br />
                •	trauma to teeth<br />
                •	displaced or loose teeth<br />
                •	sore & swollen gums<br />
                •	wisdom tooth problems.<br /><br />

                Tooth ache could be terrible to experience; you don’t have to put up with pain.
            </div>
        },
        {
            image: restorative,
            heading: "Restorative Services to improve function",
            desc: <div>Discoloured, carious, broken, cracked, worn or missing teeth/fillings can be treated or replaced by any of the following options:<br /><br />
                •	aesthetically pleasing fillings<br />
                •	onlay<br />
                •	inlay<br />
                •	veneers<br />
                •	crown &, bridge<br />
                •	implant retained crowns
            </div>
        },
        {
            image: OurServicesCardImg6,
            heading: "Regular Check-up and clean to maintain gum health",
            desc: <div>We carry out detailed examination, screening (intra oral radiographs, OPG, pictures & scans) and provide treatment options specific to you to address any concerns and ultimately improve your smile. Any sensitivity experienced whilst cleaning teeth is taken care of. We also provide specific deep clean treatments accompanied by oral hygiene instructions to address possible gum problems.</div>
        },
        {
            image: OurServicesCardImg7,
            heading: "Preventive Services to protect teeth",
            desc: <div>• mouth guards<br />
                •	occlusal splints<br />
                •	sleep devices<br />
                •	desensitizing procedures<br />
                •	protective restorations.<br /><br />
                See us for consultation if you grind your teeth, play contact sports, snore at night, have sleep apnoea, sensitive
                or worn teeth and if you experience clicking of joints (TMJ) & locked jaw.</div>
        },
        {
            image: OurServicesCardImg1,
            heading: "Root Canal Treatment (RCT) to relieve to treat infections",
            desc: <div>Root Canal Treatment (RCT) is one of the dental procedures to address pain & infection that has developed due to many reasons.
                RCT involves removing infected debris/nerve from inside the tooth,
                cleaning and shaping of the root canals and filling them. Root canal treated teeth are brittle, they normally require permanent restoration and crown</div>
        },
        {
            image: cosmetic,
            heading: "Cosmetic Services to Enhance Your Smile",
            desc: <div>Are you concerned about your smile due to discoloured teeth, spacing in between your teeth or crooked teeth?
                We can bring a smile back on your face at an affordable price. Treatment modalities include: <br /><br />
                •	digital smile design <br />
                •	in – office & at home whitening <br />
                •	direct composite veneers<br />
                •	indirect porcelain veneers<br />
                •	crown and Bridge
            </div>
        },
        {
            image: OurServicesCardImg5,
            heading: "Prosthodontic Services to replace teeth to improve function and smile",
            desc: <div>Are you missing teeth and finding it hard to chew. We can provide you with a tailor-made treatment plan to replace any missing teeth.
                Treatment options include,<br /><br />
                •	Cast metal, Acrylic and Flexible partial dentures<br />
                •	Full dentures<br />
                •	Implant retained dentures/ crown/ bridge <br />
                •	Tooth supported Bridge
            </div>
        },
        {
            image: OurServicesCardImg3,
            heading: "Orthodontic services",
            desc: <div>Do you think that your teeth are not aligned evenly,
                crowded or spaced apart or that you have a overbite causing to be unhappy with your smile?
                Or do you have retained baby teeth or impacted adult teeth? Not to worry, these problems can be addressed and aligned using <br /><br />
                •	Fixed braces or orthodontic treatment<br />
                •	Removable aligners<br />
                •	Removable appliances.
            </div>
        },
        {
            image: OurServicesCardImg10,
            heading: "Pedodontic Services to treat Children ",
            desc: <div>It’s important that, children are seen at an early age so that they get acquainted & look forward to visit dentist every 6 months.
                We make sure that, Children seen by us leave the practice happily. If the child is anxious, option of Nitrous oxide (laughing gas) and treatment under GA
                is available to make the child relaxed while dental procedure is being carried out.</div>
        },
        {
            image: OurServicesCardImg9,
            heading: "Consultations for Whitening, Crowns & etc",
            desc: <div>Consultation appointments answer questions that have been on your mind for a long time, see us to discuss about: <br /><br />
                •	Digital smile design <br />
                •	Veneers - crown and bridge<br />
                •	Braces/clear aligner treatment<br />
                •	Implants<br />
                •	Dentures<br />
                •	Mouth guard<br />
                •	Night guard for joint problems
            </div>
        },
        {
            image: OurServicesCardImg8,
            heading: "Tooth removal and Minor Oral surgery Procedures",
            desc: <div>Getting the tooth removed is not a pleasant experience. Most of you would be anxious. We understand and provide anxiety relief remedies such as nitrous
                oxide sedation for children and adults. Procedures could be performed in a day surgery under GA if required. See us for removal of wisdom teeth,
                multiple teeth followed by immediate dentures or if you think a tooth needs removal.
            </div>
        },
    ]


    return (
        <div className=' px-6 sm:px-4 overflow-visible'>
            <div className="flex justify-between items-center my-10">
                <div className="text-[36px] font-poppins font-[400]">
                    Our<br /><span className="text-[54px] text-[#1A76D1] font-[600] leading-[0.8rem]">Services</span>
                </div>
                <div className="underline mb-10 text-[#1A76D1]">
                    View All Services
                </div>
            </div>
            <div className="relative h-full bg-transparent my-10">
                <AliceCarousel
                    autoPlayInterval={8000}
                    infinite
                    autoPlayStrategy='default'
                    autoPlay
                    keyboardNavigation
                    items={OurServicesData.map((items) =>
                        <OurServicesCard
                            image={items.image}
                            heading={items.heading}
                            desc={items.desc}
                        />
                    )}
                    responsive={responsive}
                    renderNextButton={() =>
                        <div className="absolute right-[-2rem] top-1/2 transform -translate-y-1/2">
                            <IoChevronForwardCircleOutline size={36} className='hover:text-[#1A76D1] cursor-pointer' />
                        </div>
                    }
                    renderPrevButton={() =>
                        <div className="absolute left-[-2rem] top-1/2 transform -translate-y-1/2">
                            <IoChevronBackCircleOutline size={36} className='hover:text-[#1A76D1] cursor-pointer' />
                        </div>
                    }
                    disableDotsControls
                />
                <div className=" flex justify-center items-center">
                <button
                    onClick={handleBookNow}
                    className='p-2 px-8 bg-[#00D3BE] rounded-[6px] text-white text-[20px] font-[400]'>
                    Call Us/ Book Online
                </button>
            </div>
            </div>
        </div>
    )
}

export default OurServices
